import * as React from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import AutocompleteFormField from "components/autocomplete-form-field";
import { useGetProductFamiliesQuery } from "services/product-family";
import { formatDateOnlyValue } from "utils/common";

interface SelectProductFamilyProps {
  disabled?: boolean;
  manufacturer?: number;
  discontinued?: boolean;
}

export default function SelectProductFamily<T extends FieldValues>({
  name,
  control,
  disabled,
  manufacturer,
  discontinued = false
}: SelectProductFamilyProps & UseControllerProps<T>) {
  const { data, isFetching } = useGetProductFamiliesQuery(
    { discontinued, manufacturer },
    { skip: disabled }
  );

  return (
    <AutocompleteFormField
      autoFocus
      openOnFocus
      name={name}
      autoHighlight
      options={data}
      control={control}
      disabled={disabled}
      isLoading={isFetching}
      label="Product Family"
      popupIcon={<ArrowDropDownIcon />}
      getOptionLabel={(option) => option?.name ?? ""}
      renderOption={(props, option) => (
        <ListItem {...props}>
          <ListItemText>
            {option.name}:{" "}
            {formatDateOnlyValue(option.launch_date, "MM/dd/yyyy")}
          </ListItemText>
        </ListItem>
      )}
      isOptionEqualToValue={(option, value) =>
        option.description === value.description
      }
      sx={{}}
    />
  );
}
